/* tslint:disable */
/* eslint-disable */
/**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { Region } from './Region';
import {
    RegionFromJSON,
    RegionFromJSONTyped,
    RegionToJSON,
    RegionToJSONTyped,
} from './Region';
import type { PersonHandle } from './PersonHandle';
import {
    PersonHandleFromJSON,
    PersonHandleFromJSONTyped,
    PersonHandleToJSON,
    PersonHandleToJSONTyped,
} from './PersonHandle';
import type { PersonType } from './PersonType';
import {
    PersonTypeFromJSON,
    PersonTypeFromJSONTyped,
    PersonTypeToJSON,
    PersonTypeToJSONTyped,
} from './PersonType';

/**
 * Abridged person structure
 * @export
 * @interface PersonRet
 */
export interface PersonRet {
    /**
     * A flag indicating whether the person is active or not
     * @type {boolean}
     * @memberof PersonRet
     */
    active: boolean;
    /**
     * The ID of the person
     * @type {string}
     * @memberof PersonRet
     */
    person_id: string;
    /**
     * 
     * @type {PersonType}
     * @memberof PersonRet
     */
    person_type: PersonType;
    /**
     * 
     * @type {Region}
     * @memberof PersonRet
     */
    region: Region;
    /**
     * 
     * @type {Array<PersonHandle>}
     * @memberof PersonRet
     */
    handles?: Array<PersonHandle>;
    /**
     * 
     * @type {Array<string>}
     * @memberof PersonRet
     */
    groups?: Array<string>;
    /**
     * Attributes divided into named buckets. Bucket names are top level keys; attributes are values. Attributes consist of key-value pairs. Attribute names (keys) may be at most 70 bytes long. Attribute values must be JSON-serializable and are limited to 64KiB.
     * 
     * @type {{ [key: string]: { [key: string]: any; }; }}
     * @memberof PersonRet
     */
    attributes?: { [key: string]: { [key: string]: any; }; };
}



/**
 * Check if a given object implements the PersonRet interface.
 */
export function instanceOfPersonRet(value: object): value is PersonRet {
    if (!('active' in value) || value['active'] === undefined) return false;
    if (!('person_id' in value) || value['person_id'] === undefined) return false;
    if (!('person_type' in value) || value['person_type'] === undefined) return false;
    if (!('region' in value) || value['region'] === undefined) return false;
    return true;
}

export function PersonRetFromJSON(json: any): PersonRet {
    return PersonRetFromJSONTyped(json, false);
}

export function PersonRetFromJSONTyped(json: any, ignoreDiscriminator: boolean): PersonRet {
    if (json == null) {
        return json;
    }
    return {
        
        'active': json['active'],
        'person_id': json['person_id'],
        'person_type': PersonTypeFromJSON(json['person_type']),
        'region': RegionFromJSON(json['region']),
        'handles': json['handles'] == null ? undefined : ((json['handles'] as Array<any>).map(PersonHandleFromJSON)),
        'groups': json['groups'] == null ? undefined : json['groups'],
        'attributes': json['attributes'] == null ? undefined : json['attributes'],
    };
}

export function PersonRetToJSON(json: any): PersonRet {
    return PersonRetToJSONTyped(json, false);
}

export function PersonRetToJSONTyped(value?: PersonRet | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'active': value['active'],
        'person_id': value['person_id'],
        'person_type': PersonTypeToJSON(value['person_type']),
        'region': RegionToJSON(value['region']),
        'handles': value['handles'] == null ? undefined : ((value['handles'] as Array<any>).map(PersonHandleToJSON)),
        'groups': value['groups'],
        'attributes': value['attributes'],
    };
}

